import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ComparisonPersistenceService } from './comparison-persistence.service';
import { COMPARISON_FEATURE } from './store';
import { reducerProvider, reducerToken } from './store/reducers';

export function comparisonStatePersistenceFactory(
  comparisonPersistenceService: ComparisonPersistenceService,
): () => void {
  return () => comparisonPersistenceService.sync();
}

@NgModule({
  imports: [StoreModule.forFeature(COMPARISON_FEATURE, reducerToken)],
  providers: [
    reducerProvider,
    provideAppInitializer(() => {
      const initializerFn = comparisonStatePersistenceFactory(inject(ComparisonPersistenceService));

      return initializerFn();
    }),
  ],
})
export class ComparisonDataAccessModule {}
